<script>
  // Vendor
  import Velocity from 'velocity-animate';

  export default {
    name: 'staggerEntranceTransition',

    data: function () {
      return {

      }
    },

    created: function () {

    },

    mounted: function () {

    },

    methods: {
      // Transitions
      // ---------------------------------------------------
      beforeEnter: function (el) {
        el.style.opacity = 0;
      },

      enter: function (el, done) {
        var delay = el.dataset.index * 22;

        setTimeout(function () {
          Velocity(
            el,
            { opacity: 1 },
            { complete: done }
          )
        }, delay)
      },

      leave: function (el, done) {
        var delay = el.dataset.index * 0;

        setTimeout(function () {
          Velocity(
            el,
            { opacity: 0 },
            { complete: done }
          )
        }, delay)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// StaggerEntranceTransition.vue?060e73b3